var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_272_4729_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 9.18359C27.384 9.18359 29.3164 11.116 29.3164 13.5V14.625C29.3164 15.2831 28.7831 15.8164 28.125 15.8164H28C26.7942 15.8164 25.8164 16.7942 25.8164 18C25.8164 19.2058 26.7942 20.1836 28 20.1836H28.125C28.7831 20.1836 29.3164 20.7169 29.3164 21.375V22.5C29.3164 24.884 27.384 26.8164 25 26.8164H11C8.61596 26.8164 6.68359 24.884 6.68359 22.5V21.375C6.68359 20.7169 7.21685 20.1836 7.875 20.1836H8C9.20581 20.1836 10.1836 19.2058 10.1836 18C10.1836 16.7942 9.20581 15.8164 8 15.8164H7.875C7.21685 15.8164 6.68359 15.2831 6.68359 14.625V13.5C6.68359 11.116 8.61596 9.18359 11 9.18359H25ZM15 21.8164C14.6226 21.8164 14.3164 22.1226 14.3164 22.5V23.5C14.3164 23.8774 14.6226 24.1836 15 24.1836C15.3774 24.1836 15.6836 23.8774 15.6836 23.5V22.5C15.6836 22.1226 15.3774 21.8164 15 21.8164ZM15 16.8164C14.6226 16.8164 14.3164 17.1226 14.3164 17.5V18.5C14.3164 18.8774 14.6226 19.1836 15 19.1836C15.3774 19.1836 15.6836 18.8774 15.6836 18.5V17.5C15.6836 17.1226 15.3774 16.8164 15 16.8164ZM15 11.8164C14.6226 11.8164 14.3164 12.1226 14.3164 12.5V13.5C14.3164 13.8774 14.6226 14.1836 15 14.1836C15.3774 14.1836 15.6836 13.8774 15.6836 13.5V12.5C15.6836 12.1226 15.3774 11.8164 15 11.8164Z",
    fill: "url(#paint0_linear_272_4729)",
    stroke: "#141C2A",
    strokeWidth: 0.633358
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_272_4729_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_4729",
    x1: 18,
    y1: 9.5,
    x2: 18,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FED7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2D12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.3d745f5cd788c8ca4d1b96114eae6b79.svg";
export { ForwardRef as ReactComponent };